'use client';

import { datadogRum } from '@datadog/browser-rum-slim';
import Frog from '../public/emo-frog-1.svg';
import { useEffect } from 'react';

import './globals.css';

import { BaseLink } from '@/components/shared/Link/Link';
import { isProdEnvironment } from '@/utils/environment';

export interface ErrorProps {
  error: Error & { digest?: string };
}

export default function GlobalError({ error }: ErrorProps) {
  useEffect(() => {
    if (!isProdEnvironment()) {
      console.error(error);
    }

    datadogRum.addError(error);
  }, [error]);

  return (
    <html>
      <body className="antialiased">
        <div className="mt-24">
          <div className="content-wrapper flex flex-col">
            <div className="w-full flex flex-col sm:flex-row m-auto md:justify-start">
              <div className="grid sm:grid-cols-2 gap-12">
                <div className="font-sans font-semibold text-kale">
                  <p className="text-heading-xl mb-6">Uh-oh! An error has occured.</p>
                </div>
                <Frog className="mx-auto max-w-100 object-scale-down" />
              </div>
            </div>
            <BaseLink
              asButton
              href="https://www.chime.com"
              className="inline-flex items-center justify-center text-label origin-center transition-all hover:bg-bg-action-primary-hover active:bg-bg-action-primary-hover active:scale-95 no-underline label-saans font-semibold rounded-md cursor-pointer md:max-w-max py-2 px-4 border-transparent text-(--btn-text) bg-(--btn-bg) text-wrap border-[1.5px] leading-tight min-w-40 w-50">
              Back to homepage
            </BaseLink>
          </div>
        </div>
      </body>
    </html>
  );
}
